import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { StudentData } from '../../types/Student';

const initialState: StudentData = {
  gradeId: null,
  gradeName: null,
  classId: null,
  className: null,
};

const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    setStudentData: (state, action: PayloadAction<StudentData>) => {
      return { ...state, ...action.payload };
    },
    resetStudentData: () => initialState,
  },
});

export const { setStudentData, resetStudentData } = studentSlice.actions;
export default studentSlice.reducer;
